import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, computed, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ApmTranslatePipe } from '@mitsubishi/core';
import { ProjectSelectionsFacade, Selection } from '@mitsubishi/project/data-access';
import { SelectionStatus } from '@mitsubishi/shared/data-access';
import { BaseUiModule, ButtonComponent } from '@mitsubishi/shared/ui';

@Component({
  selector: 'apm-quote-selection',
  templateUrl: './quote-selection.component.html',
  styleUrls: ['./quote-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ButtonComponent, ApmTranslatePipe, BaseUiModule],
})
export class QuoteSelectionComponent {
  selectedSelection = signal<Selection | undefined>(undefined);

  projectQuotes = computed(() => {
    return this.quoteFacade
      .selectionsSignal()
      .filter(selection => selection?.details?.status === SelectionStatus.QUOTE_DRAFT);
  });

  constructor(
    private quoteFacade: ProjectSelectionsFacade,
    private dialogRef: MatDialogRef<QuoteSelectionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { unitId: string }
  ) {}

  quoteSelected(selection: Selection) {
    this.selectedSelection.set(selection);
  }

  save() {
    this.dialogRef.close(this.selectedSelection());
  }
}
